export default "__VITE_ASSET__CQo47qn9__"